// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import ApiAutocompleteController from './api_autocomplete_controller.js';
import BankAccountFormController from './bank_account_form_controller.js';
import CarouselStimulusController from './components/stimulus_carousel.js';
import CopyToClipboardController from './copy_to_clipboard_controller.js';
import CspReporterController from './csp_reporter_controller.js';
import DashboardMetricsController from './admin/dashboard_metrics_controller.js';
import DistributorFormController from './admin/users/distributors/form_controller.js';
import FormController from './form_controller.js';
import FormToggleController from './form_toggle_controller.js';
import GenerateTokenController from './generate_token_controller.js';
import GtmController from './gtm_controller.js';
import IbanChannelController from './iban_channel_controller.js';
import InvestFormController from './invest_form_controller.js';
import LemonwayIframeController from './users/profile_information/onboarding/lemonway_iframe_controller.js';
import LendingTimetableFormController from './lending_time_table_controller.js';
import ModalController from './modal_controller.js';
import NativeInformationsFormCardController from './users/profile_information/native_informations_form_card_controller.js';
import NestedFormController from './nested_form_controller.js';
import OtpModalController from './otp_modal_controller.js';
import PasswordVisibilityController from './password_visibility_controller.js';
import PayoutFormController from './payout_form_controller.js';
import PoliticalExpositionController from './political_exposition_controller.js';
import ProjectSectionSelectorController from './admin/project_section_selector_controller.js';
import RedactorController from './redactor_controller.js';
import SidebarController from './sidebar_controller.js';
import SpecialPurposeVehicleFormController from './admin/special_purpose_vehicle_form_controller.js';
import SuitabilityQuestionnaireController from './suitability_questionnaire_controller.js';
import ToastrController from './toastr_controller.js';
import TomSelectController from './tom_select_controller.js';
import ScrollIndicatorController from './scroll_indicator_controller.js';
import ScrollNavController from './scroll_nav_controller.js';

application.register('api-autocomplete', ApiAutocompleteController);
application.register('carousel-stimulus', CarouselStimulusController);
application.register('political-exposition', PoliticalExpositionController);
application.register('tom-select', TomSelectController);
application.register('sidebar', SidebarController);
application.register('lending-timetable-form', LendingTimetableFormController);
application.register('nested-form', NestedFormController);
application.register('redactor', RedactorController);
application.register('password-visibility', PasswordVisibilityController);
application.register(
  'project-section-selector',
  ProjectSectionSelectorController,
);
application.register('lemonway-iframe', LemonwayIframeController);
application.register(
  'special-purpose-vehicle-form',
  SpecialPurposeVehicleFormController,
);
application.register('invest-form', InvestFormController);
application.register('distributor-form', DistributorFormController);
application.register('generate-token', GenerateTokenController);
application.register('copy-to-clipboard', CopyToClipboardController);
application.register('iban-channel', IbanChannelController);
application.register('modal', ModalController);
application.register('otp-modal', OtpModalController);
application.register('bank-account-form', BankAccountFormController);
application.register('payout-form', PayoutFormController);
application.register('form', FormController);
application.register('form-toggle', FormToggleController);
application.register('scroll-nav', ScrollNavController);
application.register('scroll-indicator', ScrollIndicatorController);
application.register('dashboard-metrics', DashboardMetricsController);
application.register('suitability-questionnaire', SuitabilityQuestionnaireController);
application.register('native-informations-form-card', NativeInformationsFormCardController);
application.register('toastr', ToastrController);
application.register('gtm', GtmController);
application.register('csp-reporter', CspReporterController);
